import { Controller } from "@hotwired/stimulus"

// Caps the recent-scans list at MAX rows after each Turbo Stream prepend, and
// hides the empty-state placeholder once the first row arrives.
export default class extends Controller {
  static targets = ["empty"]

  static MAX = 5

  connect() {
    this.list = this.element.querySelector("#recent-scans-list")
    if (!this.list) return

    this.observer = new MutationObserver(() => this.trim())
    this.observer.observe(this.list, { childList: true })
    this.trim()
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  trim() {
    if (!this.list) return

    const rows = this.list.querySelectorAll(":scope > li")
    for (let i = this.constructor.MAX; i < rows.length; i++) {
      rows[i].remove()
    }

    if (this.hasEmptyTarget) {
      this.emptyTarget.hidden = rows.length > 0
    }
  }
}
